// extracted by mini-css-extract-plugin
export default {"formItem":"CheckboxField_formItem__5o2y-","wrapper":"CheckboxField_wrapper__D-j6t","fieldName":"CheckboxField_fieldName__a-Wor","options":"CheckboxField_options__PCVJs"};